/**
 *
 */
export var SeedPhraseType;
(function (SeedPhraseType) {
    SeedPhraseType["Twelve"] = "12-words";
    SeedPhraseType["Eighteen"] = "18-words";
    SeedPhraseType["TwentyFour"] = "24-words";
})(SeedPhraseType || (SeedPhraseType = {}));
/**
 *
 */
export var AppType;
(function (AppType) {
    AppType["app"] = "app";
    AppType["currency"] = "currency";
    AppType["plugin"] = "plugin";
    AppType["tool"] = "tool";
    AppType["swap"] = "swap";
})(AppType || (AppType = {}));
//# sourceMappingURL=manager.js.map